<section class="container py-5 text-center" aria-live="polite">
  <ng-container *ngIf="!errorMessage">
    <h1>Connexion en cours</h1>
    <p>Votre session Castorama est en cours de finalisation.</p>
  </ng-container>

  <ng-container *ngIf="errorMessage">
    <h1>Connexion impossible</h1>
    <p class="error">{{ errorMessage }}</p>
    <ng-casto-btn class="blue" label="Réessayer" (click)="retry()"></ng-casto-btn>
  </ng-container>
</section>
